<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        class="mt-2,mb-2"
        style="margin-right:0.5em;border-radius:8px;margin-top:-7px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Teacher Event Dashboard</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row class="pt-10" justify="center">
          <v-card class="box filter-box">
            <v-row justify="center">
              <v-col cols="12" sm="6" md="6">
                <b class="ml-3">Event State</b
                ><v-icon class="pl-1 pb-3" color="error">*</v-icon>
                <v-radio-group
                  v-model="radios"
                  mandatory
                  row
                  class="ma-2 no-display"
                >
                  <v-radio label="All" value="all" color="#0f2027"></v-radio>
                  <v-radio
                    label="Active"
                    value="active"
                    color="#0f2027"
                  ></v-radio>
                  <v-radio
                    label="Inactive"
                    value="inactive"
                    color="#0f2027"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <b>Event</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
                <v-autocomplete
                  dense
                  v-model="eventList"
                  :items="filteredEvents"
                  item-text="name"
                  item-value="id"
                  name="Event"
                  return-object
                  outlined
                  hint="Please select the event"
                  persistent-hint
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2" md="2" class="mt-9">
                <v-btn class="info" v-model="fetch" @click="getEventInfo"
                  >Fetch</v-btn
                >
              </v-col>
            </v-row>
          </v-card>
        </v-row>
        <v-row v-if="fetch" justify="center" class="pt-10">
          <v-simple-table class="simple-table elevation-5">
            <thead>
              <th>Event Name</th>
              <th>Event Description</th>
              <th>From</th>
              <th>To</th>
            </thead>
            <tbody>
              <tr v-for="item in tableData" :key="item.id">
                <td>{{ item.name }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.from_date_time }}</td>
                <td>{{ item.end_date_time }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-row>

        <v-row justify="center" class="pt-10">
          <v-btn v-if="fetch && eventList.name !== 'All'" class="button1 mr-8" color="primary" @click="addSlot()"
            >Add Slot</v-btn
          >
          <v-btn
            class="mt-2"
            outlined
            color="blue"
            @click="addMeetLink()"
            >Add Meeting link
            <v-icon class="ml-2">mdi-link</v-icon>
          </v-btn>
        </v-row>        
      </v-card>
      <v-dialog v-model="dialog" max-width="700">
          <v-card>
            <v-card-title style="background-color: lightgrey">
              <v-icon class="mr-2">mdi-calendar</v-icon>
              Add Slot
            </v-card-title>
            <v-card-text>
              <v-row justify="center">
                <v-col cols="12" sm="4" md="4">
                  <b>Event</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                  <v-text-field
                    readonly                    
                    filled
                    dense
                    height="5"
                    v-model="selectedEventName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <b>Slot Name</b
                  ><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                  <v-text-field
                    label="Slot Name"
                    v-model="slotName"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" sm="4" md="4" align="center">
                  <b>Date</b><v-icon class="pl-1 pb-2" color="error">*</v-icon
                  ><br />
                  <input
                    type="date"
                    v-model="selectedEventDate"
                    id="date"
                    name="date"
                    :min="minDate"
                    :max="maxDate"
                  />
                </v-col>
                <v-col cols="12" sm="4" md="4" align="center">
                  <b>From Time</b><v-icon class="pl-1 pb-2" color="error">*</v-icon
                  ><br />
                  <input
                    type="time"
                    v-model="selectedEventFromTime"
                    id="time"
                    name="time"
                  />
                </v-col>
                <v-col cols="12" sm="4" md="4" align="center">
                  <b>To Time</b><v-icon class="pl-1 pb-2" color="error">*</v-icon
                  ><br />
                  <input
                    type="time"
                    v-model="selectedEventEndTime"
                    id="time2"
                    name="time"
                  />
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="4" md="4" class="pb-0">
                  <v-checkbox
                    v-model="IsOnline"
                    color="success"
                    style=" margin-top: 45px"
                    label="Is Online Meeting ?"
                    @change="showMsg"
                    ><b></b
                  ></v-checkbox>
                </v-col>
                <v-col v-if="showLink" cols="12" sm="7" md="7" class="ml-8">
                  <v-text-field
                    v-model="meeting_link"
                    label="Meeting Link"
                    style="margin-bottom: -15px; margin-top: 45px"
                    readonly
                    filled
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="4" md="4" class="pb-0">
                  <v-checkbox
                    v-model="IsCommon"
                    color="success"
                    style="margin-top: 23px"
                    label="Is Common Slot ?"
                    ><b></b
                  ></v-checkbox>
                </v-col>
                <v-spacer></v-spacer>
                <v-col v-if="!IsCommon" cols="12" sm="6" md="6" class="">
                  <b style="">Applicable To</b> <br />
                  <v-row>
                    <v-col cols="12" sm="6" md="6" style="margin-left: -24px">
                      <v-autocomplete
                        dense
                        v-model="std"
                        :items="standard_list_all"
                        item-text="standard"
                        item-value="id"
                        name="Standard"
                        outlined
                        multiple
                        @change="get_divisions_stream(std, 'standard')"
                        hint="Standard"
                        persistent-hint
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" v-if="division_list != ''">
                      <v-autocomplete
                        dense
                        v-model="div"
                        item-text="divname"
                        item-value="id"
                        name="Division"
                        :items="division_list"
                        multiple
                        outlined
                        hint="Division"
                        persistent-hint
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="plain" @click="close">Close</v-btn>
              <v-btn color="primary" variant="tonal" @click="saveSlotDetails"
                >Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog2" max-width="600">
          <v-card>
            <v-card-title>
              <v-icon class="mr-2">mdi-link-variant</v-icon>
              Add Meeting Link
            </v-card-title>
            <v-card-text>
              <v-text-field
                label="Enter meeting link"
                outlined
                dense
                v-model="newMeetingLink"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="plain" @click="dialog2 = false;">Close</v-btn>
              <v-btn @click="saveLink" color="primary">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <v-card class="box">
        <v-row dense>
          <v-col cols="12" sm="6" md="6" class="mb-2 ml-2">
              <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'Appointment Details')"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
          </v-col>
        </v-row>
        <v-data-table :headers="headers" id="my-table-id" :items="event_time_slot_list" :search="search">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Appointment Details</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field v-model="search" background-color="white" append-icon="search" label=" Search" single-line hide-details class="no-display"></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:item.student="{ item }">
            <span v-if="item.bookings && item.bookings.length > 0">
              <span v-for="(booking, index) in item.bookings" :key="index">
                {{ booking.learner_name}}<span v-if="index < item.bookings.length - 1">, </span>
              </span>
            </span>
            <span v-else>--</span>
          </template>
          <template v-slot:item.parent="{ item }">
            <span v-if="item.bookings && item.bookings.length > 0">
              <span v-for="(booking, index) in item.bookings" :key="index">
                {{ booking.booked_by}}<span v-if="index < item.bookings.length - 1">, </span>
              </span>
            </span>
            <span v-else>--</span>
          </template>
          <template v-slot:item.standard="{ item }">
            <span v-if="item.bookings && item.bookings.length > 0">
              <span v-for="(booking, index) in item.bookings" :key="index">
                {{ booking.standard_name}}<span v-if="index < item.bookings.length - 1">, </span>
              </span>
            </span>
            <span v-else>--</span>
          </template>
          <template v-slot:item.division="{ item }">
            <span v-if="item.bookings && item.bookings.length > 0">
              <span v-for="(booking, index) in item.bookings" :key="index">
                {{ booking.division_name}}<span v-if="index < item.bookings.length - 1">, </span>
              </span>
            </span>
            <span v-else>--</span>
          </template>
          <template v-slot:item.applicable_details="{ item }">
            <v-icon
              v-if="item.applicable_details.length > 0"
              @click="openApplicableToDialog(item.applicable_details)"
              class="cursor-pointer"
              >mdi-eye</v-icon
            > 
            <span v-else>All</span>           
          </template>
          <template v-slot:item.slot_type="{ item }">
            <span v-if="item.meeting_link">Online</span>
            <span v-else>Offline</span>
          </template>
          <template v-slot:item.meeting_link="{ item }">
            <v-icon
              v-if="item.meeting_link"
              @click="openLinkDialog(item.meeting_link)"
              class="cursor-pointer"
              >mdi-eye</v-icon
            >
            <span v-else>--</span>
          </template>
          <template v-slot:item.edit="{ item }">
          <div v-if="item.can_delete">
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="cursor-pointer" @click="openEditDialog(item)" title="edit">edit</v-icon>
            </v-avatar>
          </div>
          <div v-else>--</div>
        </template>
        <template v-slot:item.delete="{ item }">
          <div v-if="item.can_delete">
            <v-avatar size="35">
              <v-icon class="cursor-pointer" @click="openDeleteDialog(item)" color="red">mdi-trash-can</v-icon>
            </v-avatar>
          </div>
          <div v-else>--</div>
        </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialogLink" max-width="600">
        <v-card>
          <v-card-title class="">Meeting Link</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="selectedMeetingLink"
              label="Meeting Link"
              readonly
              outlined
              append-outer-icon="mdi-content-copy"
              @click:append-outer="copyLink(selectedMeetingLink)"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dialogLink = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="applicableTodialog" max-width="400">
        <v-card>
          <v-card-title>Slot Applicable To</v-card-title>
          <v-card-text>
            <v-simple-table>
              <thead style="background-color: lightgrey;">
              <th>Standard</th>
              <th>Division</th>
              </thead>
              <tbody>
                <tr v-for="(details, index) in slotAppliedTo" :key="index">
                  <td>{{ details.standard_name}}</td>
                  <td>{{ details.division_name}}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="applicableTodialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editDialog" max-width="700">
        <v-card>
          <v-card-title class="edit-dialog">
            <v-icon class="mr-2" color="white">mdi-calendar-today</v-icon>
            Edit Appointment Details
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" sm="3" md="3" class="pt-0" align-self="center">
                <b>Slot Name </b>
              </v-col>
              <v-col cols="12" sm="9" md="9" >
                 <v-text-field class="pt-2" v-model="selectedSlot.name" dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="3" md="3" class="pt-5" align-self="center">
                <b> Date & Time </b>
              </v-col>
                <v-col cols="12" sm="3" md="3">
                  <b>Date</b><v-icon class="pl-1 pb-2" color="error">*</v-icon
                  ><br />
                  <input type="date" v-model="selectedSlot.date_edit" id="date" name="date" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <b>From Time</b><v-icon class="pl-1 pb-2" color="error">*</v-icon
                  ><br />
                  <input type="time" v-model="selectedSlot.from_time_edit"  id="time" name="time" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                  <b>To Time</b><v-icon class="pl-1 pb-2" color="error">*</v-icon
                  ><br />
                  <input type="time" v-model="selectedSlot.to_time_edit"  id="time2" name="time2" />
                </v-col>
              </v-row>
            <v-row dense>
              <v-col cols="12" sm="3" md="3" class="pt-0" align-self="center">
                <b>Applicable To </b>
              </v-col>
              <v-col cols="12" sm="9" md="9">
                <v-textarea v-model="formattedApplicableDetails" readonly filled class="mt-0" rows="1" no-resize></v-textarea>
                <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-autocomplete
                        dense
                        v-model="selectedSlot.applicable_to_standard_ids"
                        :items="standard_list_all"
                        item-text="standard"
                        item-value="id"
                        name="Standard"
                        outlined
                        multiple
                        @change="stdChange"
                        hint="Standard"
                        persistent-hint
                      ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="division_list != ''">
                  <v-autocomplete
                        dense
                        v-model="selectedSlot.applicable_to_div_ids"
                        item-text="divname"
                        item-value="id"
                        name="Division"
                        :items="division_list"
                        multiple
                        outlined
                        @change="divChange"
                        hint="Division"
                        persistent-hint
                      ></v-autocomplete>
                </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="3" md="3" class="pt-0" align-self="center">
                <b>Slot Type </b>
              </v-col>
              <v-col cols="12" sm="9" md="9" >
                  <v-checkbox
                    v-model="IsOnline"
                    color="success"
                    label="Is Online Meeting ?"
                    ><b></b
                  ></v-checkbox>             
              </v-col>
            </v-row>
            <v-row dense>
              <v-col v-if="IsOnline" cols="12" sm="3" md="3" class="pt-0" align-self="center">
                <b>Meeting link </b>
              </v-col>
              <v-col v-if="IsOnline && selectedSlot.meeting_link" cols="12" sm="9" md="9" >
                <v-text-field
                  v-model="selectedSlot.meeting_link"
                  dense                  
                  label="Enter Meeting Link"
                ></v-text-field>
              </v-col>
              <v-col v-else-if="IsOnline" cols="12" sm="9" md="9" >
                <v-text-field
                  v-model="this.meeting_link"
                  dense                  
                  label="Enter Meeting Link"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" sm="3" md="3" class="pt-0" align-self="center">
                <b>Booking Date Time </b>
              </v-col>
              <v-col cols="12" sm="9" md="9" >
                <v-text-field class="pt-2" v-model="this.selectedSlot.from_date_time_edit" readonly filled height="5" dense ></v-text-field>
              </v-col>
            </v-row>
            <br>
            <v-row dense>
              <v-spacer></v-spacer>
              <v-btn text class="mr-3" variant="plain" @click="closeEditDialog">Close</v-btn>              
              <v-btn @click="saveUpdatedDetails" color="success">Update</v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteDialog" max-width="500">
        <v-card>
          <v-card-title>Delete Slot</v-card-title>
          <v-card-text><b>Are you sure you want to delete this slot?</b></v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteDialog = false">Cancel</v-btn>
            <v-btn color="error" @click="deleteSlot">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Add Event Slot Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/kld0OC8bYiM?si=MYWXPOowlQB6e-Ks""
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    videoDialog:false,
    overlay: false,
    title: "",
    description: "",
    headers: [
      { text: "Sr.No.", value: "srno" },
      { text: "Event Name", value: "event_name" },
      { text: "Slot Name", value: "name" },
      { text: "From", value: "from_date_time" },
      { text: "To", value: "end_date_time" },
      { text: "Slot For", value: "slotfor" },
      { text: "Slot Applicable To", value: "applicable_details" },
      { text: "Slot Type", value: "slot_type" },
      { text: "Meeting link", value: "meeting_link" },
      { text: "Slot status", value: "event_status" },
      { text: "Student", value: "student" },
      { text: "Parent", value: "parent" },
      { text: "Standard", value: "standard" },
      { text: "Division", value: "division" },
      { text: "Booking Date Time", value: "from_date_time" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
    ],
    event_state: { name: "Active", id: 1 },
    eventList: { name: "All", id: null },
    event_state_list: [
      { name: "Active", id: 1 },
      { name: "Inactive", id: 2 },
      { name: "All", id: 3 },
    ],
    event_list: [],
    standard_list_all: [],
    event_time_slot_list: [],
    division_list: [],
    tableData: [],
    fetch: false,
    dialog: false,
    IsOnline: false,
    IsCommon: false,
    std: null,
    dialog2: false,
    slotName: "",
    date: new Date().toISOString().substr(0, 10),
    FromTime: new Date().toTimeString().substr(0, 5),
    ToTime: new Date().toTimeString().substr(0, 5),
    std: "",
    div: "",
    newMeetingLink: "",
    ay_id: null,
    division_list: [],
    radios: null,
    selectedEventName:"",
    dialogLink: false,
    selectedMeetingLink: '',
    meeting_link: "",
    showLink: false,
    editDialog: false,
    selectedSlot: {},
    slotType: "",
    search: "",
    formattedApplicableDetails:"",
    deleteDialog: false,
    selectedSlotForDelete : null,
    can_delete: false,
    applicableTodialog: false,
    slotAppliedTo: [],
    new_div_ids: [],
    minDate: "",
    maxDate: "",
    selectedEventDate: "",
    selectedEventFromTime: "",
    selectedEventEndTime: "",
  }),
  computed: {
    filteredEvents() {
      if (this.radios === "all") {
        return this.event_list;
      } else if (this.radios === "active") {
        return this.event_list.filter((event) => event.isactive);
      } else if (this.radios === "inactive") {
        return this.event_list.filter((event) => !event.isactive).filter(event=> event.name != "All");
      }
      return this.event_list;
    },
  },
  methods: {
    openLinkDialog(link) {
      this.selectedMeetingLink = link;
      this.dialogLink = true;
    },
    openApplicableToDialog(set){
      this.applicableTodialog = true;
      this.slotAppliedTo = set;
    },
    copyLink(link) {
      navigator.clipboard.writeText(link).then(
        () => {
          this.showSnackbar("success","Link copied to clipboard!");
        },
        () => {
          this.showSnackbar("error","Failed to copy link");
        }
      );
    },
    openEditDialog(slot) {
      this.selectedSlot = {
        ...slot,
      };
      this.IsOnline = !!slot.meeting_link;
      this.formattedApplicableDetails = slot.applicable_details.map(item => {
        return `${item.standard_name}-${item.division_name}`;
      }).join(', ');
      this.editDialog = true;
    },
    stdChange(newStandards){
      this.selectedSlot.applicable_to_standard_ids = newStandards;   
      this.get_divisions_stream(newStandards, 'standard');
    },
    divChange(newDivisions){
      // console.log("new divisions"+newDivisions);
      this.selectedSlot.applicable_to_div_ids = newDivisions;
    },
    saveUpdatedDetails(){
      if(this.selectedSlot.applicable_to_standard_ids.length > 0 && this.selectedSlot.applicable_to_div_ids.length <= 0){
        this.showSnackbar("error","Please select division/s");
        return;
      }

      const validDivisions = this.selectedSlot.applicable_to_div_ids.filter(divId =>
      this.new_div_ids.includes(divId));

      const data = {
        event_slot_id: this.selectedSlot.id,
        date: this.selectedSlot.date_edit,
        from_time: this.selectedSlot.from_time_edit,
        to_time: this.selectedSlot.to_time_edit,
        name: this.selectedSlot.name,
        standard: this.selectedSlot.applicable_to_standard_ids,
        div: validDivisions,
        is_online: this.IsOnline,
        meeting_link : this.IsOnline ? this.meeting_link :  this.IsOnline && this.selectedSlot.meeting_link ? this.selectedSlot.meeting_link : null
      }
      axios
        .post("Appointment/saveEditEventSlotDetails", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.showSnackbar("success", "Updated successfully");
            this.event_time_slot_list = res.data.event_time_slot_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
        })
        .finally(() => {
          this.editDialog = false;
          this.division_list = "";
        });
    },
    closeEditDialog(){
      this.editDialog = false;
      this.division_list = "";
    },
    openDeleteDialog(item){
      this.deleteDialog = true;
      this.selectedSlotForDelete = item;
    },
    deleteSlot(){
      const data = {
        event_slot_id: this.selectedSlotForDelete.id,
      }
      axios
        .post("Appointment/deleteEventSlot", data)
        .then((res) => {
          if (res.data.msg == "200") {
            this.showSnackbar("success", "Deleted successfully");
            this.event_time_slot_list = this.event_time_slot_list.filter(slot => slot.id !== this.selectedSlotForDelete.id);
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
        })
        .finally(() => {
          this.deleteDialog = false;
        });
    },
    resetform() {
      this.slotName= "";
      this.selectedEventDate = this.splitDateTime(this.eventList.from_date_time).date;
      this.selectedEventFromTime = this.splitDateTime(this.eventList.from_date_time).time;
      this.selectedEventEndTime = this.splitDateTime(this.eventList.end_date_time).time;
      this.IsOnline = false;
      this.IsCommon = "";
      this.std = "";
      this.div = "";
      this.showLink = false;
    },
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text =
        tab_text + "<table style='border-collapse:collapse;' border='1'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      exportTable.find("th, td").each(function () {
        $(this).css("border", "1px solid black");
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
      const blob = new Blob([tab_text], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const filename = name + ".xls";

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    getEventInfo() {
      this.selectedEventName=this.eventList.name;
      this.fetch = true;
      if (this.eventList) {
        if ((this.eventList.name === "All")) {
          this.tableData = this.event_list.filter(
            (event) => event.name != "All"
          );
        } 
        else {
          this.tableData = [
            {
              ...this.eventList,
            },
          ];
        }

        this.fetchEventSlots();
        const fromdateTimeParts = this.splitDateTime(this.eventList.from_date_time);
        const todateTimeParts = this.splitDateTime(this.eventList.end_date_time);

        this.minDate = fromdateTimeParts.date;
        this.maxDate = todateTimeParts.date;
        this.selectedEventDate = fromdateTimeParts.date;

        this.selectedEventFromTime = fromdateTimeParts.time;
        this.selectedEventEndTime = todateTimeParts.time;
      }
       else {
        this.tableData = [];
      }      
    },
    splitDateTime(dateTime){
      console.log(dateTime);
      const [date, time, period] = dateTime.split(" ");
      const [day, month, year] = date.split("/");
      const formattedDate = `${year}-${month}-${day}`;
      // console.log(formattedDate);

      let[hours, minutes] = time.split(":");
      if (period === "PM" && parseInt(hours) < 12) {
        hours = (parseInt(hours, 10) + 12).toString();
      } else if (period === "AM" && hours === "12") {
        hours = "00";
      }
      const formattedTime = `${hours.padStart(2, "0")}:${minutes}`;
      // console.log(formattedTime);

      return { date: formattedDate, time: formattedTime };
    },
    get_divisions_stream(standard, type) {
      if (type == "standard") {
        const formData = {
          ay: this.ay_id,
          standard: standard,
        };
        axios
          .post("/Communication/get_standard_divisions", formData)
          .then((res) => {
            if (res.data.flag == "Yes") {
              this.division_list = res.data.division_list;
              this.new_div_ids = res.data.applicable_to_div_ids;
            }
          })
          .catch((error) => {
            this.showSnackbar("#b71c1c", "Something went wrong...");
          })
          .finally(() => {
            // this.stream = "";
          });
      }
    },
    saveSlotDetails() {
      if(this.date == '' || this.FromTime == '' || this.ToTime == '' || this.slotName.trim() == '') {
        this.showSnackbar("error","Please fill all required fields");
        return;
      }
      if(this.IsCommon == false && this.std == '' && this.div == '')
      {
        this.showSnackbar("error","Either check 'Is common slot' or select standard/s and division/s");
        return;
      }
      const data = {
        event_id: this.eventList.id,
        date : this.selectedEventDate,
        from_time: this.selectedEventFromTime,
        to_time: this.selectedEventEndTime,
        standard: this.IsCommon ? null : this.std,
        div: this.IsCommon ? null : this.div,
        meeting_link: this.IsOnline ? this.meeting_link : null,
        iscommonslot: this.IsCommon,
        name: this.slotName,
      };
      axios
        .post("Appointment/saveTeacherEventSlot", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("success", "Saved successfully");
            this.event_time_slot_list = res.data.event_time_slot_list;
          }else if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
          else {
            this.showSnackbar("#b71c1c", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
        })
        .finally(() => {
          this.dialog = false;
          this.resetform();
        });
    },

    fetchEventSlots() {

      const eventid = this.eventList.name === "All" ? "All" : this.eventList.id;
      const data = {
        event_id: eventid
      };
      axios
        .post("Appointment/fetchEventSlots", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.event_time_slot_list = res.data.event_time_slot_list;
          }else if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
          }
          else {
            this.showSnackbar("#b71c1c", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
        });
    },
    addSlot() {
      this.dialog = true;
    },
    showMsg(){
      if(this.IsOnline){
          if(this.meeting_link === null) {
          this.showSnackbar("error","Please add new meeting link");
          this.showLink = false;
        }
        else {
          this.showLink = true;
        }
      }
      else{
        this.showLink =  false;
      }
      
    },
    saveLink(){
      if(this.newMeetingLink == '') {
        this.showSnackbar("error","Please enter the link");
        return;
      }
      let link = this.newMeetingLink.trim();
      if (!link.startsWith("http://") && !link.startsWith("https://")) {
        link = "https://" + link;
      }
      this.newMeetingLink = link;
      const data = {
        meeting_link : this.newMeetingLink,
      }
      axios
        .post("Appointment/saveInstructorMeetingLink", data)
        .then((res) => {
          if (res.data.flag == "Yes") {
            this.showSnackbar("success", "Link Saved successfully");
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
        })
        .finally(() => {
          this.dialog2 = false;
          this.newMeetingLink = "";
          this.onload();
        });
    },
    close(){
      this.dialog = false;
      this.resetform();
    },
    addMeetLink() {
      this.newMeetingLink = this.meeting_link || '';
      this.dialog2 = true;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("Appointment/getTeacherEvents")
        .then((res) => {
          if (res.data.flag == "YES") {
            // this.showSnackbar("success","Data fetched successfully !!!")
            this.standard_list_all = res.data.standard_list_all;
            this.event_time_slot_list = res.data.event_time_slot_list;
            this.event_list = res.data.event_list;
            this.ay_id = res.data.ay_id;
            this.meeting_link = res.data.meeting_link;
            this.can_delete = res.data.event_time_slot_list.can_delete;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
  watch: {},
};
</script>
<style scoped>
.filter-box {
  width: 50% !important;
}
.mytable {
  width: 95%;
  justify-items: center;
}
.simple-table th {
  background-color: rgb(188, 207, 224);
  font-size: 13px;
}
.simple-table {
  width: 60%;
}
.edit-dialog {
  background-color: royalblue;
  color: white;
}
.v-textarea {
    margin-top: 0px !important;
}
</style>